module.exports = __webpack_public_path__ + "static/media/idun4.cceb3d88.JPG";